import * as React from 'react';
import { useState, useMemo } from 'react';
import {
  Box,
  Container,
  CssBaseline,
  Stepper,
  Step,
  StepLabel,
  Button,
  Grid,
} from '@mui/material';
import Log from '../../lib/log';
import { useNavigate } from 'react-router-dom';
import { useSelector } from '../../store/store';
import LectureTestCall from '../organisms/LectureTestCall';
import LectureSetupTransfer from '../organisms/LectureSetupTransfer';

// ログの初期化
const log = new Log('Lecture');

// ステップ
const steps = ['動作確認', '転送設定'];

export default function Lecture() {
  log.putLog('info', 'Lecture started.');

  // setupUser
  const [setupUser] = useState(useSelector((state) => state.setupUser));

  // ナビゲート
  const navigate = useNavigate();

  // ステップ管理
  const [activeStep, setActiveStep] = useState(0);
  const totalSteps = () => steps.length;
  const isLastStep = () => activeStep === totalSteps() - 1;

  // 次へ
  const handleNext = () => {
    if (isLastStep()) {
      return navigate('/');
    } else {
      setActiveStep(activeStep + 1);
    }
  };

  useMemo(() => {
    if (!setupUser.id) navigate('/');
  }, [setupUser, navigate]);

  return (
    <Container component='main' maxWidth='lg' sx={{ mt: 4, mg: 4 }}>
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
      <Grid container justifyContent='center'>
        <Grid item xs={0} md={2} lg={2} />
        <Grid item xs={12} md={8} lg={8}>
          {activeStep === 0 ? <LectureTestCall /> : ''}
          {activeStep === 1 ? <LectureSetupTransfer /> : ''}
        </Grid>
        <Grid item xs={0} md={2} lg={2} />
      </Grid>
      <Grid container justifyContent='center'>
        <Grid key='next' item padding={2}>
          <Button variant='contained' onClick={handleNext}>
            {isLastStep() ? 'ユーザーサイトに移動する' : '次へ'}
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
}
